<template>
  <div>
    <page-header :title="title" :breadcrumb="breadcrumb" :container-class="containerClass" />
    <div class="page-section">
      <div :class="containerClass">
        <page-separator :title="title" />

        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center" style="white-space: nowrap">
              <!-- Search -->
              <div class="col-lg-auto">
                <form class="search-form search-form--light d-lg-inline-flex mb-8pt mb-lg-0" @submit.prevent="">
                  <b-form-input class="w-lg-auto" placeholder="Search Prizes" v-model="searchTerm" @input="onSearch" />
                  <b-btn variant="flush" type="submit">
                    <md-icon v-text="'search'" />
                  </b-btn>
                </form>
              </div>

              <!-- Filters and Add Btn -->
              <div class="col-lg d-flex flex-wrap justify-content-end">
                <!-- TODO: Add filters here. (if needed) -->
                <!-- <b-dropdown class="ml-lg-auto" :text="$t('All Topics')" variant="link text-black-70" right>
                  <b-dropdown-item active>All Topics</b-dropdown-item>
                  <b-dropdown-item>My Topics</b-dropdown-item>
                </b-dropdown>

                <b-dropdown class="mr-8pt" :text="$t('Newest')" variant="link text-black-70" right>
                  <b-dropdown-item active>Newest</b-dropdown-item>
                  <b-dropdown-item>Unanswered</b-dropdown-item>
                </b-dropdown> -->

                <b-btn :to="{ name: 'add-prize' }" exact variant="primary">Post prize</b-btn>
              </div>
            </div>
          </div>

          <!-- Events Table -->
          <b-table
            :fields="tableColumns"
            :items="prizes"
            :busy="isLoading"
            head-variant="light"
            class="table-nowrap"
            hover
            responsive
            no-local-sorting
            @sort-changed="onSortChange"
            @row-clicked="editPrize"
          >
            <template #cell(name)="data">
              <strong> {{ data.item.name }} </strong>
            </template>

            <template #cell(image)="data">
              <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside">
                <b-img :src="data.item.image" class="img-fluid" width="40" alt="Logo" v-if="data.item.image" />
                <i class="material-icons" v-else>card_giftcard </i>
              </fmv-avatar>
            </template>
            <template #cell(is_active)="data">
              <b-badge
                :class="`border border-${data.item.is_active ? 'success' : 'danger'} text-${
                  data.item.is_active ? 'success' : 'danger'
                }`"
                variant="none"
                >{{ data.item.is_active ? 'Active' : 'Inactive' }}</b-badge
              >
            </template>

            <template #cell(schools_count)="data">
              <a href="#" @click.prevent="openRedeemedTable(data.item)" class="text-primary">{{
                get(data.item, 'schools_count', 0)
              }}</a>
            </template>

            <template #head(actions)="">
              <span></span>
            </template>
            <template #cell(actions)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret @click.stop>
                <template #button-content>
                  <i class="material-icons icon-24pt text-info">more_vert</i>
                </template>
                <b-dropdown-item @click.stop="updateStatus(data.index)">
                  <md-icon :class="data.item.is_active ? 'text-danger mr-2' : 'text-success mr-2'">{{
                    data.item.is_active ? 'block' : 'check_circle_outline'
                  }}</md-icon>
                  {{ data.item.is_active ? 'Mark Inactive' : 'Mark Active' }}
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click.stop :to="{ name: 'edit-prize', params: { id: data.item.id } }">
                  <md-icon class="text-info mr-2">edit</md-icon>
                  {{ $t('generalMsgs.edit') }}
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click.stop="confirmDeletePrize(data.item.id)">
                  <md-icon class="text-danger mr-2">delete</md-icon>
                  {{ $t('generalMsgs.remove') }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>

          <!-- Footer Pagination -->
          <div class="card-footer">
            <pagination
              v-model="currentPage"
              :total-rows="totalPrizes"
              :per-page="perPage"
              @change="onPageChange"
              aria-controls="prizes-table"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/Ui/PageHeader.vue';
import PageSeparator from '@/components/Ui/PageSeparator.vue';
import { FmvAvatar } from 'fmv-avatar';
import { debounce, get } from 'lodash';
import { mapActions } from 'vuex';

import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import MdIcon from '../../../components/Ui/MdIcon.vue';
import { DEFAULT_PAGE_SIZE } from '../../../common/constants';

export default {
  components: { MdIcon, PageHeader, PageSeparator, Pagination, FmvAvatar },
  extends: Page,

  data() {
    return {
      title: 'Manage Prizes',

      isLoading: false,
      areAttendeeCountsLoading: false,
      perPage: DEFAULT_PAGE_SIZE,
      currentPage: 1,
      totalPrizes: 0,
      prizes: [],

      searchTerm: '',
      ordering: '',
    };
  },

  computed: {
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Prizes', active: true },
      ];
    },

    tableColumns() {
      return [
        {
          key: 'actions',
          label: '',
          class: 'text-left',
          thStyle: { minWidth: '120px' },
        },
        { key: 'image', label: '', tdClass: 'clickable-item' },
        { key: 'title', label: 'Title', tdClass: 'clickable-item' },
        { key: 'is_active', label: 'Status' },
        { key: 'total_credits', label: 'Credits Required' },
        { key: 'schools_count', label: 'Redemption Count' },
      ];
    },
  },

  methods: {
    ...mapActions('credit', ['getAllPrizes', 'deletePrize', 'updatePrizeStatus']),
    get,
    async updateStatus(index) {
      this.isLoading = true;
      const currStatus = this.prizes[index].is_active;
      try {
        const isConfirmed = await this.$bvModal.msgBoxConfirm(
          `Please confirm that you want to mark the status ${currStatus ? 'Inactive' : 'Active'}.`,
          {
            title: 'Are you sure?',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (isConfirmed) {
          await this.updatePrizeStatus({ id: this.prizes[index].id, data: { is_active: !currStatus } });
          this.fetchPrizes();
          this.makeToast({ variant: 'success', msg: 'Status changed successfully!' });
        }
      } catch (error) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isLoading = false;
    },
    openRedeemedTable(row) {
      if (row.schools_count) {
        this.$router.push({ name: 'manage-redeem-prizes', query: { prize: row.id } });
      }
    },
    async fetchPrizes(pageNum = 1, params = {}) {
      this.isLoading = true;
      document.getElementById('app').scrollIntoView();

      const response = await this.getAllPrizes({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...(this.ordering && { ordering: this.ordering }),
        ...(this.searchTerm && { search: this.searchTerm }),
        ...params,
      });
      this.prizes = response.data.results;
      this.currentPage = pageNum;
      this.totalPrizes = response.data.count;

      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchPrizes(pageNum);
    },

    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchPrizes();
    },

    onSearch() {
      this.debouncedSearchPrizes(this);
    },

    debouncedSearchPrizes: debounce((vm) => {
      vm.fetchPrizes();
    }, 500),

    editPrize(row) {
      this.$router.push({ name: 'edit-prize', params: { id: row.id } });
    },

    async confirmDeletePrize(id) {
      try {
        const isConfirmed = await this.$bvModal.msgBoxConfirm(
          "Please confirm that you want to delete the selected prize and it's related data.",
          {
            title: 'Are you sure?',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (isConfirmed) {
          await this.deletePrize(id);
          const refreshPage = this.prizes.length > 1 ? this.currentPage : this.currentPage - 1;
          this.fetchPrizes(refreshPage || 1);
          this.makeToast({ variant: 'success', msg: 'Prize Successfully Deleted' });
        }
      } catch (error) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
  },

  async mounted() {
    this.fetchPrizes();
  },
};
</script>
